/**
 * File upload configurations and constants
 */

export const ACCEPTED_FILE_TYPES = {
  PDF: { "application/pdf": [".pdf"] },
  PDF_AND_IMAGES: {
    "application/pdf": [".pdf"],
    "image/jpeg": [".jpg", ".jpeg"],
    "image/png": [".png"],
  },
  EXCEL: {
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
    "application/vnd.ms-excel": [".xls"],
    "text/csv": [".csv"],
  },
} as const;

export const FILE_UPLOAD_CONFIG = {
  MAX_FILES: 1,
  MAX_SIZE: 10 * 1024 * 1024, // 10MB
  MAX_COMMENT_ATTACHMENTS: 5, // Máximo archivos por comentario
} as const;

export const FILE_ICONS = {
  PDF: "text-red-600",
  EXCEL: "text-green-600",
  IMAGE: "text-blue-600",
} as const;
